import RequestCache from "./RequestCache";
//import RequestAbstract from "./RequestAbstract";

export default class Cabinets extends RequestCache {
    get cacheInterval() {
        return 7;
    }
    
    get link() {
        return this.links.cabinets;
    }

    async getCabinets(domainId) {
        const arr = [
            { field: "domainId", op: "=", value: domainId },
            { field: "status", op: "=", value: "ACTIVE" }
        ];

        const req = await this.getAllFiltered([arr]);
        return req;
    }


}
